module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white content-padded bargain-box"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.form.title.length) + "/20")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动海报",
      "prop": "ad_pic"
    }
  }, [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("点击图片可更换，图片大小不能超过 2MB")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgChange
    }
  }, [(_vm.form.ad_pic) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.ad_pic
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间",
      "prop": "bargains_datetime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择开始日期时间"
    },
    model: {
      value: (_vm.form.bargains_datetime_begin),
      callback: function($$v) {
        _vm.$set(_vm.form, "bargains_datetime_begin", $$v)
      },
      expression: "form.bargains_datetime_begin"
    }
  }), _vm._v(" ~ "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择结束日期时间"
    },
    model: {
      value: (_vm.form.bargains_datetime_end),
      callback: function($$v) {
        _vm.$set(_vm.form, "bargains_datetime_end", $$v)
      },
      expression: "form.bargains_datetime_end"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动规则",
      "prop": "bargain_rules"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.bargain_rules),
      callback: function($$v) {
        _vm.$set(_vm.form, "bargain_rules", $$v)
      },
      expression: "form.bargain_rules"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "翻牌图片",
      "prop": "bargain_pics"
    }
  }, [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("建议图片尺寸151px * 185px，图片大小不能超过 2MB")]), _vm._v(" "), _c('div', {
    staticClass: "pics-box"
  }, [_c('div', {
    staticClass: "pics-list"
  }, [_vm._l((_vm.form.help_pics), function(item, index) {
    return [_c('div', {
      staticClass: "pics-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bg-mask"
    }, [_c('i', {
      staticClass: "icon el-icon-edit-outline",
      on: {
        "click": function($event) {
          return _vm.picsEdit(index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.picsDelete(index)
        }
      }
    })])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handlePicsChange
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 2)]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.picsDialog,
      "sc-status": _vm.isGetPics
    },
    on: {
      "chooseImg": _vm.pickPics,
      "closeImgDialog": _vm.closePicsDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "item_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.form.item_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_name", $$v)
      },
      expression: "form.item_name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.form.item_name.length) + "/20")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品图片",
      "prop": "item_pics"
    }
  }, [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("建议图片尺寸618px * 610px，点击图片可更换，图片大小不能超过 2MB")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleProductPicChange
    }
  }, [(_vm.form.item_pics) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.item_pics
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.productPicDialog,
      "sc-status": _vm.isGetProductPic
    },
    on: {
      "chooseImg": _vm.productPic,
      "closeImgDialog": _vm.closeProductPicDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品原价",
      "prop": "mkt_price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.form.mkt_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "mkt_price", $$v)
      },
      expression: "form.mkt_price"
    }
  }), _vm._v(" 元，最多保留两位小数,原价至少要比底价大￥1\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品底价",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  }), _vm._v(" 元，最多保留两位小数\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "助力人数",
      "prop": "people_range"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "最少人数"
    },
    model: {
      value: (_vm.form.people_min),
      callback: function($$v) {
        _vm.$set(_vm.form, "people_min", $$v)
      },
      expression: "form.people_min"
    }
  }), _vm._v(" ~ "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "min": "2",
      "placeholder": "最多人数"
    },
    model: {
      value: (_vm.form.people_max),
      callback: function($$v) {
        _vm.$set(_vm.form, "people_max", $$v)
      },
      expression: "form.people_max"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品数量",
      "prop": "limit_num"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.form.limit_num),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_num", _vm._n($$v))
      },
      expression: "form.limit_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品详情",
      "prop": "item_intro"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.item_intro,
      "id": "1",
      "height": 360,
      "width": 600
    },
    on: {
      "change": _vm.updateProductDetail
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n        ")]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享内容",
      "prop": "share_msg"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "280px"
    },
    model: {
      value: (_vm.form.share_msg),
      callback: function($$v) {
        _vm.$set(_vm.form, "share_msg", $$v)
      },
      expression: "form.share_msg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bccd40bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bccd40bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/bargain/add.vue
// module id = 2918
// module chunks = 0